<div *ngIf="preview" class="cover-container">
    <div #cover class="content">
        <ng-container *ngIf="!themeLoading && theme; else noTheme">
            <div class="content-image-background" *ngIf="theme?.teasing?.background?.type === 'Image'" [attr.id]="themeBackgroundHtmlIdentifier"
                appBackgroundImage="{{ theme?.teasing?.background?.url }}"></div>
            <div class="container-video" *ngIf="theme?.teasing?.background?.type === 'Youtube' || theme?.teasing?.background?.type === 'Vimeo' || theme?.teasing?.background?.type === 'Video'"
                [attr.id]="themeBackgroundHtmlIdentifier">
                <app-smash-player 
                    [fullscreen]="true" 
                    [source]="playerSource" 
                    [options]="playerOptions" 
                    class="smash-sound-player"
                    context="cover"
                    (readyToPlay)="isVideoBgReadyToPlay($event)" 
                    [allowConcurrency]="true" 
                    [unstoppable]="true">
                </app-smash-player>
                <div [ngClass]="{'fadeOut': showVideo}" class="video-overlay-loading"></div>
            </div>
            <app-smash-theme-tracking [theme]="theme"></app-smash-theme-tracking>
        </ng-container>

        <ng-template #noTheme>
            <ng-container *ngIf="!!preview?.transfer?.customization?.background; else initialBackground">
                <app-smash-iframe class="container-background-image"
                    [attr.id]="preview?.transfer?.customization?.background?.id ? preview.transfer.customization.background.id : null"
                    [scriptUrl]="preview.transfer.customization.background.sourceUrl"
                    *ngIf="preview?.transfer?.customization?.background?.type === 'Iframe'">
                </app-smash-iframe>
                <!-- Image background -->
                <div class="content-image-background" *ngIf="preview?.transfer?.customization?.background?.type === 'Image'"
                    [appBackgroundImage]="preview.transfer.customization.background.sourceUrl"
                    [attr.id]="preview?.transfer?.customization?.background?.id ? preview?.transfer?.customization?.background?.id : null">
                </div>
                <!-- Youtube/Vimeo background -->
                <div class="container-video"
                    [attr.id]="preview?.transfer?.customization?.background?.id ? preview?.transfer?.customization?.background?.id : null"
                    *ngIf="preview?.transfer?.customization?.background?.type === 'Youtube' || preview?.transfer?.customization?.background?.type === 'Vimeo'">
                    <app-smash-player 
                        [fullscreen]="true" 
                        [source]="playerSource" 
                        [options]="playerOptions" 
                        context="cover"
                        class="smash-sound-player"
                        (readyToPlay)="isVideoBgReadyToPlay($event)" 
                        [allowConcurrency]="true" 
                        [unstoppable]="true"></app-smash-player>
                    <div [ngClass]="{'fadeOut': showVideo}" class="video-overlay-loading"></div>
                </div>
            </ng-container>

            <!-- Forced Image background -->
            <ng-template #initialBackground>
                <div class="content-image-background fallback-background"></div>
            </ng-template>
        </ng-template>


        <app-smash-header [theme]="theme" [headerColor]="preview?.transfer?.customization?.layoutHeaderColor"
            [captionColor]="preview?.transfer?.customization?.captionColor"
            [shadowOnElementsEnabled]="preview?.transfer?.customization?.layoutShadowElementEnabled" [showMenu]="true"
            (menuToggle)="onToggleMenu($event)" [state]="menuDisplayed$ | async" headerLocation="viewer">
        </app-smash-header>

        <!-- See Files content -->
        <ng-container *ngIf="!isDownloading && files?.length">
            <div class="content-see-files" *ngIf="isTransferAvailable" (click)="showPreview()">
                <div class="tag" [ngClass]="{'fadeIn': showSeeFiles }">
                    <i class="icon-smash_down"></i>
                </div>
            </div>
        </ng-container>
        <app-downloader *ngIf="isDownloading" [device]="device" [customization]="preview.transfer.customization"></app-downloader>
    </div>

    <div class="content-wrapper-container" [ngClass]="{'content-wrapper-container-hidden': isDownloading}">
        <div class="content-tooltip-wrapper">
            <div class="content-tooltip-container opacity-transition">
                <ng-container *ngIf="isTransferAvailable; else transferNotAvailable">
                    <app-smash-tooltip *ngIf="filesReady" position="top" delay="1000" class="smash-tooltip" (click)="onToolTipClick()">
                        <div class="line1">{{ 'VIEWER_CLICK_TO_DOWNLOAD' | translate }}</div>
                        <div class="line2">{{preview.transfer.title}}</div>
                        <!-- Switch tooltip text container -->
                        <div class="line3">
                            <div [ngClass]="{'visible': currentTooltipState === 'in'}" class="expiration">
                                <app-smash-countdown [endDate]="preview.transfer.availabilityEndDate">
                                </app-smash-countdown>
                            </div>
                            <div [ngClass]="{'visible':  currentTooltipState === 'out'}">
                                {{preview.transfer.size | bytes:2}} -
                                <span translate [translateParams]="{ count: preview.transfer.filesNumber }">VIEWER_FILES</span>
                            </div>
                        </div>
                    </app-smash-tooltip>
                </ng-container>
                <ng-template #transferNotAvailable>
                    <app-smash-tooltip position="top" delay="3000" displayed="true" class="smash-tooltip">
                        <div class="line1">{{ 'VIEWER_IN_LINE' | translate}}</div>
                        <div class="line4">{{ 'VIEWER_AVAILABLE_IN' | translate}}</div>
                        <div class="line2">
                            {{ preview.transfer.availabilityStartDate | countdown }}
                        </div>
                    </app-smash-tooltip>
                </ng-template>
            </div>
            <ng-container *ngIf="isTransferAvailable; else spinnerUnactive">
                <div *ngIf="filesReady" class="content-center-container">
                    <ng-container *ngIf="displayThemeSpinner">
                        <div class="content-spinner-container">
                            <app-smash-spinner (click)="onToolTipClick()" [url]="theme?.teasing?.centralLogo"></app-smash-spinner>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="displayTransferPreviewSpinner">
                        <div class="content-spinner-container">
                            <app-smash-spinner [url]="preview?.transfer?.customization?.logo?.sourceUrl"
                                [waveColor]="preview?.transfer?.customization?.logo?.waveColor" (click)="onToolTipClick()">
                            </app-smash-spinner>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="!displayThemeSpinner && !displayTransferPreviewSpinner">
                        <div class="content-spinner-container">
                            <app-smash-spinner (click)="onToolTipClick()"></app-smash-spinner>
                        </div>
                    </ng-container>

                    <app-smash-manufacture [color]="preview?.transfer?.customization?.manufactureColor"
                        [shadowEnabled]="preview?.transfer?.customization?.layoutShadowElementEnabled" *ngIf="isMainDomain && !theme"
                        [selectedLanguage]='selectedLanguage$ | async'>
                    </app-smash-manufacture>
                    <app-smash-trustpilot *ngIf="isMainDomain"class="trustpilot"></app-smash-trustpilot>
                </div>
            </ng-container>
            <ng-template #spinnerUnactive>
                <div class="content-center-container">
                    <ng-container *ngIf="!!preview?.transfer?.customization?.logo?.sourceUrl; else noLogo">
                        <div class="content-spinner-container">
                            <app-smash-spinner [url]="preview?.transfer?.customization?.logo?.sourceUrl"
                                [waveColor]="preview?.transfer?.customization?.logo?.waveColor">
                            </app-smash-spinner>
                        </div>
                    </ng-container>
                    <ng-template #noLogo>
                        <div class="content-spinner-container">
                            <app-smash-spinner>
                            </app-smash-spinner>
                        </div>
                    </ng-template>
                    <app-smash-manufacture *ngIf="isMainDomain && !theme" [selectedLanguage]='selectedLanguage$ | async'>
                    </app-smash-manufacture>
                    <app-smash-trustpilot *ngIf="isMainDomain"class="trustpilot"></app-smash-trustpilot>

                </div>
            </ng-template>
        </div>
    </div>
</div>